export default __webpack_public_path__ + "./images/fb.249b60d5.svg";